import { Platform } from 'react-native';

/**
 * `nativeID` / `aria-labelledby` target for the Order Summary heading and optional region landmark.
 * Same pattern as `RECEIPT_ORDER_DETAILS_TITLE_NATIVE_ID` on the receipt page.
 */
export const CHECKOUT_ORDER_SUMMARY_TITLE_NATIVE_ID = 'checkout-order-summary-title';

/**
 * One assistive announcement and a tab stop on web (mirrors `receiptFocusableLabeledProps` in
 * `workspaces/frontend/src/pages/receipt/receipt-a11y.ts`).
 */
export function checkoutFocusableLabeledProps(accessibilityLabel: string) {
  return {
    accessible: true as const,
    accessibilityLabel,
    ...(Platform.OS === 'web' ? { tabIndex: 0 as const } : {}),
  };
}
